import 'whatwg-fetch';
import 'isomorphic-fetch';
import 'core-js/stable/promise';
import 'core-js/stable/symbol';
import 'core-js/stable/string/starts-with';
import 'core-js/web/url';
// 以上是一些兼容低端浏览器添加的库
import Vue from 'vue';
// 全局引入
import '@/assets/theme/index.css';
import '@/assets/scss/index.scss';
import Element from 'element-ui';
Vue.use(Element);
import App from './App.vue';
import router from './common/router';
import vuex from './common/vuex';
// 引入qiankun
import { registerMicroApps } from 'qiankun';
import microApps from './common/qiankun';
import './permission';
import AnalysysAgent from '@/utils/analysys';

Vue.config.productionTip = false;
Vue.prototype.$analysys = AnalysysAgent;

new Vue({
    router,
    store: vuex,
    render: h => h(App),
    mounted: () => {}
}).$mount('#saas-app');

// 注册应用
registerMicroApps(microApps, {
    // 设置假造子应用的loading
    beforeMount() {
        // console.log('子应用开始加载');
        vuex.dispatch('set_IsBeginLoadChildApp', true);
    },
    afterMount() {
        // console.log('子应用完成加载');
        vuex.dispatch('set_IsBeginLoadChildApp', false);
    }
});
